import { render } from "./PickupDropoff.vue?vue&type=template&id=6196232a&scoped=true"
import script from "./PickupDropoff.vue?vue&type=script&lang=js"
export * from "./PickupDropoff.vue?vue&type=script&lang=js"

import "./PickupDropoff.vue?vue&type=style&index=0&id=6196232a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6196232a"]])

export default __exports__